<template lang="pug">
  .main-h5
    .wechat-teach(v-if="isShowMask" v-on:click="isShowMask = false")
      .img
        img(src="@assets/home-h5/wechat-teach.png")
    .header
      .img
        img(src="@assets/home-h5/1.jpg")
      .logo
      .text-contain
        .text 唯品会旗下
        .text 专业代购批发平台
        .btns
          a(:href="appleUrl" @click="aclick(1)")
            .btn 下载IOS版 >
          a(target="_blank" v-on:click="downloadApk" :href="apkUrl" @click="aclick(2)")
            .btn.android 下载安卓版 >
    .common
      .img
        img(src="@assets/home-h5/2.jpg")
    .common
      .img
        img(src="@assets/home-h5/3.jpg")
    .common
      .img
        img(src="@assets/home-h5/4.jpg")
    .common
      .img
        img(src="@assets/home-h5/5.jpg")
    .common
      .img
        img(src="@assets/home-h5/6.jpg")
    .common
      .img
        img(src="@assets/home-h5/7.jpg")
    .common
      .img
        img(src="@assets/home-h5/8.jpg")
    <!--.common-->
      <!--.img-->
        <!--img(src="@assets/home-h5/9.jpg")-->
    .footer
      .right Copyright © 2008-2018 vip.com，All Rights Reserved
      .beian
        a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010302111111" target="_blank") 粤公网安备 44010302111111号
        a(href="https://beian.miit.gov.cn/" target="_blank")  粤ICP备08114786号
</template>

<script>
import mars from '@/lib/mars'
import api from '@/lib/api'

export default {
  name: 'Home-h5',
  data () {
    return {
      isWechat: false,
      isShowMask: false,
      apkUrl: this.$globalConfig.apkUrl,
      appleUrl: this.$globalConfig.appleUrl
    }
  },

  methods: {
    downloadApk: function(e) {
      // if (this.isWechat) {
      //   // e.preventDefault()
      //     this.isShowMask = true
      // }
    },
    aclick(params) {
      if (params === 1) {
        mars.send('active_fenxiao_h5_official_web_IOS_download')
      } else {
        mars.send('active_fenxiao_h5_official_web_Android_download')
      }
    },
    getApkLink() {
      // 请求安卓下载链接
      api.getApkLink().then(res => {
        const data = res.data || {}
        const androidApkLink = data.androidApkLink 
        if (androidApkLink) {
          this.apkUrl = androidApkLink
        }
      })
    }
  },
  created() {
    mars.send('active_fenxiao_h5_p_official_web')
    this.getApkLink()
  },
  mounted () {
    this.isWechat = /micromessenger/g.test(navigator.userAgent.toLowerCase())

    this.$tracker.page('wdg_page_official_website', {
      page_id: 4 // behalf wholesale 代购批发
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
a,&:link, &:active, &:active,&:visited
  text-decoration none
  color inherit
.main-h5
  width 100%
  max-width 20rem
  margin auto
  font-size 0
  img
    width 100%
    height auto
  .wechat-teach
    position fixed
    width 100%
    height 100%
    background rgba(0,0,0,.5)
    z-index 2
    .img
      width 4.14rem
      height 3.20rem
      position absolute
      right .2rem
      top 0

  .header
    .logo
      position absolute
      top 0
      left 13.75%
      width 1.47rem
      height 1.08rem
      background url("../assets/home-h5/0.png") no-repeat top center
      background-size contain
    .text-contain
      font-size .57rem
      color #fff
      position absolute
      left 13.75%
      top 20.15625%
      width 86.25%
      .btns
        position absolute
        margin-top .5rem
        .android:hover
          .qrcode
            display block
        .btn
          background rgb(237,0,50)
          color #fff
          text-align center
          padding 0.2rem
          font-size .32rem
          font-weight normal
          font-stretch normal
          letter-spacing 0
          display inline-block
          vertical-align top
          margin .2rem

  .bottom
    background rgb(237,0,50)
    height 5rem
    color #fff
  .footer
    padding .4rem 0
    background #ccc
    font-size .24rem
    line-height:.4rem
    text-align center
    color #565656
</style>



// WEBPACK FOOTER //
// src/views/home-h5.vue